import React from "react";
import { useTranslation } from "react-i18next";
import {
    ModalOverlay,
    ModalContent,
    ModalTitle,
    ModalText,
    ModalButtons,
    ModalButton,
} from "./styled";
import { useDialogA11y } from "../shared/useDialogA11y";

type DeleteConfirmModalProps = {
    mainColor: string;
    onCancel: () => void;
    onConfirm: () => void;
};

export function DeleteConfirmModal({
    mainColor,
    onCancel,
    onConfirm,
}: DeleteConfirmModalProps): JSX.Element {
    const { t } = useTranslation();
    const { dialogRef, titleId } = useDialogA11y({ onCancel });
    return (
        <ModalOverlay
            data-testid="scan-to-banner-delete-modal-overlay"
            onClick={onCancel}
        >
            <ModalContent
                ref={dialogRef}
                role="dialog"
                aria-modal="true"
                aria-labelledby={titleId}
                data-testid="scan-to-banner-delete-modal"
                onClick={(e) => e.stopPropagation()}
            >
                <ModalTitle
                    id={titleId}
                    data-testid="scan-to-banner-delete-modal-title"
                >
                    {t("Delete image")}
                </ModalTitle>
                <ModalText data-testid="scan-to-banner-delete-modal-text">
                    {t("Do you want to confirm the deletion of this image?")}
                </ModalText>
                <ModalButtons>
                    <ModalButton
                        data-testid="scan-to-banner-delete-modal-cancel"
                        onClick={onCancel}
                    >
                        Annuler
                    </ModalButton>
                    <ModalButton
                        data-testid="scan-to-banner-delete-modal-confirm"
                        variant="danger"
                        mainColor={mainColor}
                        onClick={onConfirm}
                    >
                        Supprimer
                    </ModalButton>
                </ModalButtons>
            </ModalContent>
        </ModalOverlay>
    );
}
